import React from 'react';

import WhiteTextTypography from 'components/Common/WhiteTextTypography';

import Styles from './index.module.css';

function RemindDashboard() {
  return (
    <div
      className={Styles.container}
    >
      <WhiteTextTypography fontSize="20px">儲值金專款用，請選擇對應的項目進行儲值</WhiteTextTypography>
      <WhiteTextTypography fontSize="20px">儲值預算花費，廣告就會立即停止</WhiteTextTypography>
      <WhiteTextTypography fontSize="20px">建議您提早儲值，以免影響廣告成效喔!</WhiteTextTypography>
    </div>
  );
}

export default RemindDashboard;
